import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import config from "../../hoa-config";

export interface Organization {
	id: string;
	name: string;
}

interface OrganizationModalProps {
	isOpen: boolean;
	onClose: () => void;
	onComplete: (orgId: string) => void;
}

const OrganizationModal: React.FC<OrganizationModalProps> = ({ isOpen, onClose, onComplete }) => {
	const [selectedOrg, setSelectedOrg] = useState("");

	useEffect(() => {
		if(isOpen) {
			setSelectedOrg("");
		}
	}, [isOpen]);

	const handleSelectChange = (event: any) => {
		setSelectedOrg(event.target.value);
	};

	const handleNextClick = () => {
		if (selectedOrg) {
			onComplete(selectedOrg);
			onClose();
		}
	};

	return (
		<Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>Select Organization</DialogTitle>
			<DialogContent>
				<FormControl fullWidth margin="normal">
					<InputLabel id="organization-select-label">Organization</InputLabel>
					<Select
						labelId="organization-select-label"
						id="organization-select"
						value={selectedOrg}
						onChange={handleSelectChange}
						label="Organization"
					>
						<MenuItem value="">
							<em>Select an organization</em>
						</MenuItem>
						{config.hoaOrganizations.map((org: Organization) => (
							<MenuItem key={org.id} value={org.id}>
								{org.name}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="inherit">
					Cancel
				</Button>
				<Button
					onClick={handleNextClick}
					color="primary"
					disabled={!selectedOrg}
					variant="contained"
				>
					Next
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default OrganizationModal;
